import { Navigate, useRoutes, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { resetInvoiceSearch } from './redux/globalData/invoiceSearchSlice';
import { resetUsersSearch } from './redux/globalData/usersSearchSlice';

// layouts
import DashboardLayout from './layouts/dashboard/index';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Blog from './pages/Blog';
// import Users from './pages/dashboard/Users';
import Notifications from './pages/dashboard/Notifications';

import Login from './pages/Login';
import NotFound from './pages/Page404';
import Register from './pages/Register';
import Products from './pages/Products';
import DashboardApp from './pages/dashboard/DashboardApp';
import Customers from './pages/dashboard/customers/Customers';
// import Support from './pages/dashboard/Support';
import Profile from './pages/dashboard/Profile';
import ForgotPassword from './pages/ForgotPassword';
import EmployerCertificate from './pages/dashboard/EmployerCertificate';
import HolidayPayout from './pages/dashboard/HolidayPayout';
import EmailTemplates from './pages/dashboard/children/EmailTemplates';
import InvoiceTool from './pages/dashboard/invoice-tool/InvoiceTool';
import Users from './pages/dashboard/users/Users';
import SocialUsers from './pages/dashboard/SocialUsers';
import Salaries from './pages/dashboard/salaries/Salaries';
import { ViewHolidayPay } from './pages/dashboard/salaries/holiday-pay/ViewHolidayPay';
import { ViewUsers } from './pages/dashboard/salaries/calendar/ViewUsers';
import ViewSalaryTab from './pages/dashboard/salaries/salary/ViewSalaryTab';
import HolidaySavings from './pages/dashboard/holiday-savings/HolidaySavings';
import PensionSavings from './pages/dashboard/pension-savings/PensionSavings';
import HolidayDetails from './pages/dashboard/holiday-savings/HolidayDetail';
import PensionDetails from './pages/dashboard/pension-savings/PensionDetail';
import Invoices from './pages/dashboard/invoices/Invoices';
import LogsUI from './pages/dashboard/LogsUI';
import LoyaltyDashboard from './pages/dashboard/users/loyalty-dashboard';
import LoyaltyDashboardUser from './pages/dashboard/users/loyalty-dashboard-user';
// import AmbassadorUsers from './pages/dashboard/AmbassadorUsers';
import PreInsurance from '../src/pages/dashboard/pre-insurance/PreInsurance';
import FortnoxReconciliation from './pages/dashboard/FortnoxReconciliation';

// ----------------------------------------------------------------------

export default function Router() {
  const location = useLocation();
  const dispatch = useDispatch();
  const [pageSize, setPageSize] = useState(25);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    if (!location?.pathname?.includes('dashboard/holiday-savings')) {
      localStorage.removeItem('holidayId');
    }
    if (!location?.pathname?.includes('dashboard/pension-savings')) {
      localStorage.removeItem('pensionId');
    }
    
    // Clear search states when navigating away from specific pages
    const currentPath = location?.pathname;
    
    // Define invoice-related pages
    const isInvoiceRelatedPage = currentPath?.includes('/invoices') || 
                               currentPath?.includes('/invoice-tool') || 
                               currentPath?.includes('/view-logs');
    
    // Define users-related pages
    const isUsersRelatedPage = currentPath?.includes('/users') || 
                              currentPath?.includes('/customers') ||
                              currentPath?.includes('/user/invoices') ||
                              currentPath?.includes('/invoice-tool');
    
      if (currentPath?.startsWith('/dashboard') && !isUsersRelatedPage) {
      dispatch(resetUsersSearch());
    }
    // If navigating away from invoice pages to other dashboard pages, clear invoice search
    if (currentPath?.startsWith('/dashboard') && !isInvoiceRelatedPage) {
      dispatch(resetInvoiceSearch({ force: true }));
    }
    }, [location, dispatch]);

  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout pageSize={pageSize} pageNumber={pageNumber} searchQuery={searchQuery} />,
      children: [
        { path: 'app', element: <DashboardApp /> },
        { path: 'users', element: <Users /> },
        { path: 'users/:userId', element: <Users /> },
        { path: 'customers', element: <Customers /> },
        { path: 'assignment-registration', element: <PreInsurance /> },
        { path: 'fortnox-reconciliation', element: <FortnoxReconciliation /> },
        { path: 'customers/:customerId', element: <Customers /> },
        { path: 'user/invoices/:userId', element: <Invoices /> },
        // { path: 'support', element: <Support /> },
        { path: 'invoices', element: <Invoices /> },
        {
          path: 'salaries',
          element: <Salaries />,
          children: [
            // { path: 'view-user/:userId', element: <ViewUsers /> },
            { path: 'holiday-pay/:holidayPayId', element: <ViewHolidayPay /> },
            { path: 'salary/:salaryId', element: <ViewSalaryTab /> },
          ],
        },
        { path: 'holiday-savings', element: <HolidaySavings /> },
        { path: 'holiday-savings/:holidayId', element: <HolidayDetails /> },
        { path: 'pension-savings/:pensionId', element: <PensionDetails /> },

        {
          path: 'employer-certificate',
          element: <EmployerCertificate />,
          children: [{ path: 'view-user/:userId', element: <ViewUsers /> }],
        },

        { path: 'pension-savings', element: <PensionSavings /> },
        { path: 'notifications', element: <Notifications PageSize={setPageSize} PageNumber={setPageNumber} SearchQuery={setSearchQuery} /> },
        { path: 'profile', element: <Profile /> },
        { path: 'products', element: <Products /> },
        { path: 'blog', element: <Blog /> },
        { path: 'holiday-pay', element: <HolidayPayout /> },
        { path: 'email-templates', element: <EmailTemplates /> },
        { path: 'invoice-tool/:id', element: <InvoiceTool /> },
        { path: 'social-users', element: <SocialUsers /> },
        { path: 'loyalty-dashboard', element: <LoyaltyDashboard /> },
        { path: 'loyalty-dashboard/user/:userId', element: <LoyaltyDashboardUser /> },

        // { path: 'ambassador-users', element: <AmbassadorUsers /> },
        { path: 'view-logs', element: <LogsUI /> },
      ],
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'register',
      element: <Register />,
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/dashboard/app" /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
    {
      path: '/forgot-password',
      element: <ForgotPassword />,
    },
  ]);
}
